// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
var ReactRender = require("../../reason/utils/ReactRender.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var AutocompleteV5 = require("../autocomplete/AutocompleteV5.bs.js");
var Form__HelpLabel = require("../../uikit/reason/atoms/Form/Form__HelpLabel.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");

function getOptionLabel(param) {
  return param.name;
}

function getOptionValue(param) {
  return param.id;
}

var $$Option = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};

function DisplayNeighborhoodInputRelay(props) {
  var status = props.status;
  return JsxRuntime.jsxs(CssGrid.Cell, {
              width: 12,
              children: [
                JsxRuntime.jsx(Form__Label.make, {
                      labelText: "Display neighborhood",
                      optionalText: "optional"
                    }),
                ReactRender.fromOption(props.helpText, (function (text) {
                        return JsxRuntime.jsx(Form__HelpLabel.make, {
                                    children: text
                                  });
                      })),
                JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
                      getOptionLabel: getOptionLabel,
                      getOptionValue: getOptionValue,
                      isClearable: true,
                      isDisabled: props.isDisabled,
                      onBlur: props.onBlur,
                      onChange: props.onChange,
                      options: props.areas,
                      placeholder: Core__Option.getOr(props.placeholder, "Select a neighborhood"),
                      value: props.value,
                      status: status !== undefined ? (
                          status === "ok" ? "Success" : "Failure"
                        ) : "Neutral"
                    })
              ]
            });
}

var make = DisplayNeighborhoodInputRelay;

exports.$$Option = $$Option;
exports.make = make;
/* Form__Label Not a pure module */
